"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkedInSearch = void 0;
var react_1 = __importStar(require("react"));
var inversify_react_1 = require("inversify-react");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var GetFullName_1 = __importDefault(require("@CommonFrontendBackend/Utils/GetFullName"));
var IsPersonalEmail_1 = __importStar(require("@CommonFrontendBackend/Utils/IsPersonalEmail"));
var styles = __importStar(require("./LinkedInSearch.css"));
var linkedInUrl = "https://www.linkedin.com/search/results/all";
var LinkedInSearch = function (_a) {
    var viewer = _a.viewer, _b = _a.useLargerSize, useLargerSize = _b === void 0 ? false : _b;
    var _c = __read((0, react_1.useState)(false), 2), isHovered = _c[0], setIsHovered = _c[1];
    var telemetry = (0, inversify_react_1.useInjection)("telemetry");
    var searchString = getSearchString(viewer);
    if (!searchString)
        return null;
    var url = new URL(linkedInUrl);
    url.searchParams.append("keywords", searchString);
    return (react_1.default.createElement(kaleidoscope_1.IconButton, { className: isHovered ? undefined : styles.iconColourOverride, style: { pointerEvents: "auto" }, icon: react_1.default.createElement(icons_1.LinkedinBox, { color: "default", size: useLargerSize ? icons_1.IconSize.Medium : icons_1.IconSize.Small }), size: useLargerSize ? kaleidoscope_1.ButtonSize.Small : kaleidoscope_1.ButtonSize.XSmall, href: function () { return url.toString(); }, "aria-label": "Search on LinkedIn", tooltip: {
            content: "Search on LinkedIn",
        }, onMouseEnter: function () { return setIsHovered(true); }, onMouseLeave: function () { return setIsHovered(false); }, onClick: function () {
            return telemetry.trackOnly("Linkedin Search Button Clicked", { event_origin: "page_analytics" }, { blockIntercom: true });
        } }));
};
exports.LinkedInSearch = LinkedInSearch;
function getSearchString(_a) {
    var isIdentified = _a.isIdentified, firstName = _a.firstName, lastName = _a.lastName, email = _a.email, organisation = _a.organisation;
    if (!isIdentified)
        return null;
    var nameForSearch = "";
    if (firstName) {
        nameForSearch = (0, GetFullName_1.default)({ firstName: firstName, lastName: lastName });
    }
    else if (email) {
        nameForSearch = extractNameFromEmail(email);
    }
    if (!nameForSearch)
        return null;
    var companyForSeach = "";
    if (organisation) {
        companyForSeach = organisation;
    }
    else if (email) {
        companyForSeach = extractCompanyFromEmail(email);
    }
    return "".concat(nameForSearch, " ").concat(companyForSeach).trimRight();
}
function extractNameFromEmail(email) {
    var firstPart = email.split("@")[0];
    return firstPart.split("+")[0];
}
function extractCompanyFromEmail(email) {
    var emailDomain = (0, IsPersonalEmail_1.getEmailDomain)(email);
    if (!emailDomain)
        return "";
    if ((0, IsPersonalEmail_1.default)(email))
        return "";
    return emailDomain.split(".")[0];
}
